import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function AgentBusinessCard({ agentName, businessName }: { agentName: string; businessName: string }) {
  return (
    <Box
      sx={{
        border: '1px solid #ECECEC',
        borderRadius: '8px',
        p: 2,
        mb: 2,
        background: '#fff'
      }}
    >
      <Grid container spacing={2}>
        <Grid size={6}>
          <Typography variant='caption' color='text.secondary'>
            Agent
          </Typography>
          <Typography fontWeight={500} fontSize={14}>
            {agentName}
          </Typography>
        </Grid>
        <Grid size={6}>
          <Typography variant='caption' color='text.secondary'>
            Business
          </Typography>
          <Typography fontWeight={500} fontSize={14}>
            {businessName}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
